<script>
import List from '@/components/List/List.vue'
import FormNoSave from '@/components/Form/FormNoSave.vue'
import ToAdmin from '@/components/ToAdmin.vue'
import UserInstruction from '@/components/UserInstruction.vue'
import PopUp from '@/components/PopUp.vue'
import message from '@/helpers/message'
import CalendarWeeks from '@/components/Calendar/CalendarWeeks.vue'

export default {
    components:{ List, FormNoSave,ToAdmin, UserInstruction, PopUp, CalendarWeeks },
    data() {
        return {    
            validationErrorsForm1: [],         
            validationErrorsForm2: [],         
            sorting: [
                { name: 'name', displayName: 'Namm' },           
                { name: 'creaded_date', displayName: 'Skapad' },           
                { name: 'creaded_by', displayName: 'Skapad Av' },           
            ],
            editItem: null,
            isAdding: false,
            occations: [],     
            otherCoursesOccations: [],        
            selectedOccation: null,
            availableInstructors: [],              
            availableLocations: null,  
            selectedDay: { day: null, date: null, isBlocked: false},
            occationForm: [                   
                { sections: [{ sectionName: 'Start och slut', classes: "g-100", inputs: [ 
                    { type: 'readOnly', prop: 'date_formatted', title: 'Datum', classes: "g-100" },
                    { type: 'select', prop: 'start_time', title: 'Starttid', selectItems: 'quarters', classes: "g-100", required: true },
                    { type: 'select', prop: 'end_time', title: 'Sluttid', selectItems: 'quarters', classes: "g-100", required: true },
                    { type: 'textArea', prop: 'comments', title: 'Kommentar', classes: "g-100" }
                    ]
                    },                      
                    ],
                        backgroundColor: this.$colors.form.backgroundColor,
                        borderColor: this.$colors.form.borderColor
                }]           
        }
    },   
    created() {  
        if(this.user.user_level != 'SamfallifyCrew' && this.user.user_level != 'Redaktör')
        {
            this.$router.push('/login');
        } 
        this.$cache.createCache('accountSettings', 'account-settings/') 
    
        var id = this.$route.params.id == undefined ? 0 : this.$route.params.id;
        var self = this;
        this.isAdding = id == 0;
        this.$communicator.get('admin/courses/' + id)
        .then(function(data)
        {             
            self.availableLocations = data.course_locations;
            self.editItem = data.course;
            self.occations = [];
            for(var i = 0; i < data.course_occations.length; i++) {
                data.course_occations[i].name = 'Kurstillfälle ' + (i+1);
                self.occations.push(data.course_occations[i]);
            }
            self.otherCoursesOccations = data.other_courses_occations;
            self.availableInstructors = data.course_instructors;
        })
        .fail(function(error) {
            
        });          
    },
    methods:
    {      
        save()
        {
            var occationErrors = [];
            if(this.occations.some(x => x.start_date == null))
            {
                occationErrors.push("Alla kurstillfällen måste ha en starttid och en sluttid.");
            }
            
            
            var courseOwnerErrors = [];
            if(this.editItem.owner_ids.length == 0) {
                courseOwnerErrors.push("Du måste välja minst en kursansvarig.");
            }

            if(this.validationErrorsForm1.length > 0 || this.validationErrorsForm2.length > 0 || occationErrors.length > 0 || courseOwnerErrors.length > 0)
            {
                message.setValidationErrorMessage([...this.validationErrorsForm1, ...this.validationErrorsForm2, ...occationErrors, ...courseOwnerErrors]);
                return;
            }
            
            var self = this;
            this.editItem.occations = this.occations;
            this.$communicator.post('admin/courses/', this.editItem)
            .then(function(data)
            {                       
                message.setSuccessMessage();
                self.$router.push({ name: 'adminCourses' });                        
            })
            .fail(function(error) {                  
            })  
        },
        cancel() {
            this.$router.push({ name: 'adminCourses' });                        
        },
        showNextWeekShortCut(index) {
            if(index == 0) { return true; }
            
            var prevOccation = this.occations[index-1];
            if(prevOccation.date_formatted != null && prevOccation.start_date != null) {
                return true;
            }
            return false;
        },
        copyPreviousOccationTimes(occation, index)
        {
            var prevOccation = this.occations[index-1];

            occation.date_formatted = this.addDays(prevOccation.date_formatted, 7);
            occation.start_date = prevOccation.start_date.replace(/^\d{4}-\d{2}-\d{2}/, this.addDays(prevOccation.start_date, 7));
            occation.start_time = prevOccation.start_time;
            occation.end_date = prevOccation.end_date.replace(/^\d{4}-\d{2}-\d{2}/, this.addDays(prevOccation.end_date, 7));
            occation.end_time = prevOccation.end_time;
        },
        addDays(dateString, days) {
            const date = new Date(dateString);
            date.setDate(date.getDate() + days);
            return date.toISOString().split("T")[0]; // Only keep YYYY-MM-DD
        }
    },
    computed:
    {
        user() {return this.$store.state.user; },
        accountSettings() {return this.$store.state.accountSettings; }, 
        otherOccations() { return this.otherCoursesOccations.filter(occation => occation.course_location_id == this.editItem.course_location_id && !this.occations.some(occ => occ.id === occation.id)); },       
        form() {
            var form = [                   
                { sections: [{ sectionName: 'Namn och information', classes: "g-100", inputs: [ 
                    { type: 'text', prop: 'name', title: 'Namn', classes: "g-100", required: true },
                    { type: 'textEditor', prop: 'description', title: 'Information', classes: "g-100", required: true },                          
                            { type: 'number', prop: 'max_number_of_participents', title: 'Antal deltagare', classes: "g-100", required: true },
                            { type: 'number', prop: 'show_few_left_at_this_number', title: 'Välj antal platser kvar när "Få antal platser kvar" visas', classes: "g-100" },
                            { type: 'number', prop: 'price', title: 'Pris i kr', classes: "g-100", required: true },
                        ]
                    },
                    { sectionName: 'Plats och kursansvariga', classes: "g-100", inputs: [                     
                            { type: 'select', prop: 'course_location_id', title: 'Plats', classes: "g-100", selectItems: this.availableLocations, required: false },
                            { type: 'multiSelectBtns', prop: 'owner_ids', title: 'Välj kursansvariga', required: true, selectItems: this.availableInstructors, classes: "g-100" },                          
                        ]
                    },                        
                    ],
                        backgroundColor: this.$colors.form.backgroundColor,
                        borderColor: this.$colors.form.borderColor
                }];
            
            if(this.$store.state.accountSettings != null && this.$store.state.accountSettings.enable_public_page)
            {
                form[0].sections[0].inputs.push({ type: 'select', prop: 'is_public_course', title: 'Gör denna kurs synlig på den publika sidan', classes: "g-100", selectItems: 'yesno' });               
            }

            return form;
        },
        availableOccations() {
            var list = [];
            for(var i = 1; i <= 30; i++)
            {
                list.push({id: i, name: i.toString(), display: true, selected: false });
            }

            return list;
        },     
        form2() {
           return [                   
                { sections: [
                    { sectionName: 'Lägg till bild', classes: "g-100", inputs: [
                        { type: 'image', prop: 'image_id', title: 'Klicka på den bild du vill använda som kursbild', classes: "g-100" },                        
                        ]
                    }, 
                    { sectionName: 'Kursstart och antal tillfällen', classes: "g-100", inputs: [                     
                            { type: 'date', prop: 'course_start', title: 'Kursstart', classes: "g-50", required: true },
                            { type: 'date', prop: 'last_day_of_application', title: 'Sista anmälningsdagen', classes: "g-50", required: true },
                            { type: 'select', prop: 'number_of_occations', title: 'Antal tillfällen', classes: "g-100", required: true, selectItems: this.availableOccations },                          
                        ]
                    },
                            
                    ],
                        backgroundColor: this.$colors.form.backgroundColor,
                        borderColor: this.$colors.form.borderColor
                }]

        },

        
    },
    watch:
    {
        editItem: {
            handler(editItem){
                if(editItem != null && editItem.course_start && editItem.number_of_occations && editItem.last_day_of_application)
                {
                    var number_of_occations = parseInt(editItem.number_of_occations);
                    if(this.isAdding)
                    {
                        this.occations = [];
                        for(var i = 0; i < number_of_occations; i++)
                        {
                            this.occations.push({id: 0, date_formatted: i == 0 ? this.editItem.course_start : null, start_date: null, end_time: null, end_date: null, start_time: null, comments: null })
                        }
                    }
                    else {
                        if(this.occations.length < number_of_occations)
                        {
                            for(var i = this.occations.length; i < number_of_occations; i++)
                            {
                                this.occations.push({id: 0, date_formatted: null, start_date: null, end_time: null, end_date: null, start_time: null, comments: null })
                            }
                        }
                        else if(this.occations.length > number_of_occations)
                        {
                            this.occations.splice(number_of_occations);
                        }

                    }
                }
            },
            deep: true
        }
    }
}
</script>
<template>
    <div v-fade-in v-if="accountSettings != null && availableOccations.length > 0 && availableLocations">
        <main class="opacity-admin-bg overflow-auto position-relative">
            <div class="breadcrumbs">
                <router-link :to="{ name: 'admin' }">Startsidan: Redaktör</router-link>
                &nbsp; >>  &nbsp;
                <router-link :to="{ name: 'adminCourses' }">Kurser</router-link>
                &nbsp; >>  &nbsp;
                <b v-if="isAdding">Lägg till en kurs</b>
                <b v-else>Redigera en kurs</b>
            </div>
            <!-- <div class="float-right">              
                <UserInstruction :page="this.$route.name"></UserInstruction>
            </div> -->
            <h2 v-if="isAdding">Lägg till en kurs</h2>
            <h2 v-if="!isAdding">Redigera en kurs</h2>
            <div class="overflow-auto">
                <div v-if="editItem != null" class="g-50">
                    <FormNoSave :form="form" :item="editItem" :isEditing="true" :hideMandatoryInformation="true" :errorList="validationErrorsForm1"></FormNoSave>
                </div>            
                <div v-if="editItem != null" class="g-50">
                    <FormNoSave :form="form2" :item="editItem" :isEditing="true" :hideMandatoryInformation="true" :errorList="validationErrorsForm2"></FormNoSave>
                    <fieldset v-if="editItem != null && editItem.course_start && editItem.number_of_occations && editItem.last_day_of_application" class="AdminCourseEdit-occations">
                        <legend>Kurstillfällen</legend>
                        <div v-for="(occation,index) in occations" class="AdminCourseEdit-occation overflow-auto">
                            Kurstillfälle {{ index+1 }}: 
                            <span v-if="occation.date_formatted">
                                <button v-if="occation.start_date" class="btn btn-gray float-right" style="margin:-8px 0px 8px 0px"  @click="selectedOccation = occation">Ändra i kalendern</button> 
                            {{ occation.date_formatted }}   
                            {{ occation.start_time }} - 
                            {{ occation.end_time }}  
                                <span v-if="!occation.start_date">&nbsp;<button class="btn btn-gray" style="margin: -8px 0px 8px;" @click="selectedOccation = occation">Välj i kalendern</button></span>
                            </span>
                            <span v-else-if="showNextWeekShortCut(index)">
                               &nbsp;<button class="btn" style="margin: -8px 0px 8px;" @click="copyPreviousOccationTimes(occation, index)">Samma tid en vecka senare</button>
                                    &nbsp;<button class="btn btn-gray" style="margin: -8px 0px 8px;" @click="selectedOccation = occation">Välj i kalendern</button>                                 
                            </span>
                        </div>
                    </fieldset>         
                </div>
            </div>
            <div class="g-100 margin-top-15">
                <div class="btn float-right" @click="save">Spara</div>
                <div class="btn btn-gray float-right" @click="cancel">Avbryt</div>
            </div>   
        </main>
        <PopUp v-if="selectedOccation" :width="'90%'" :bgColor="this.$colors.list.backgroundColor">
            <div class="g-70">
                <CalendarWeeks :bookings="[]" :selectedDate="selectedOccation" :occations="occations" :otherOccations="otherOccations"></CalendarWeeks>
            </div>
            <div class="g-30 text-left">
                <div style="margin-left: 20px;">
                    <FormNoSave :form="occationForm" :item="selectedOccation" :isEditing="true"></FormNoSave>
                    <button class="btn float-right" @click="selectedOccation = null">Klar</button>
                </div>
            </div>
    </PopUp> 
    </div>
</template>
<style scoped>
    .AdminCourseEdit-occations {
        border: 1px solid rgb(196, 170, 116);
        background: rgb(240, 224, 190);
        margin: 5px;
        padding: 14px;
    }

    .AdminCourseEdit-occation {
        border-bottom: 1px dashed  rgb(196, 170, 116);
        padding: 14px 0px 0px 0px;
    }

    legend{
        font-weight: 600;
        font-size: 13px;
        text-align: left;
        text-transform: uppercase;
    }
</style>